import React from 'react'
import { Drawer, Menu } from 'antd'
import type { MenuProps } from 'antd'
import { useHistory, useLocation } from 'react-router-dom'

interface MobileMenuDrawerProps {
  visible: boolean
  onClose: () => void
}

const MobileMenuDrawer: React.FC<MobileMenuDrawerProps> = ({ visible, onClose }) => {
  const navigation = useHistory()
  const location = useLocation()

  const handleMenuClick = (url: string) => {
    navigation.push(url)
    onClose()
  }

  const menuItems = [
    {
      key: '1',
      label: '회원관리',
      onClick: () => handleMenuClick('/users'),
      children: [
        { label: '전체회원', key: '1-1', onClick: () => handleMenuClick('/users') },
        { label: '거절회원', key: '1-21', onClick: () => handleMenuClick('/users/-2') },
        { label: '신규회원', key: '1-2', onClick: () => handleMenuClick('/users/1') },
        { label: '대기회원', key: '1-22', onClick: () => handleMenuClick('/users/-1') },
        { label: '활동회원', key: '1-3', onClick: () => handleMenuClick('/users/2') },
        { label: '블랙회원', key: '1-4', onClick: () => handleMenuClick('/users/3') },
        { label: '모투회원', key: '1-5', onClick: () => handleMenuClick('/users/4') },
        { label: '파트너회원', key: '1-7', onClick: () => handleMenuClick('/users/7') },
        { label: '등급 및 수수료', key: '1-6', onClick: () => handleMenuClick('/users/5') },
        { label: '레퍼럴 관리', key: '1-8', onClick: () => handleMenuClick('/users/6') },
      ],
    },
    {
      key: '11',
      label: '그룹관리',
      onClick: () => handleMenuClick('/usergroup'),
    },
    {
      key: '2',
      label: '종목운영',
      onClick: () => handleMenuClick('/coin/coingroup'),
      children: [
        { label: '장운영현황', key: '2-1', onClick: () => handleMenuClick('/coin/coingroup') },
        { label: '해선 종목 관리', key: '2-3', onClick: () => handleMenuClick('/coin/pair') },
        { label: '시세관리', key: '2-4', onClick: () => handleMenuClick('/coin/price') },
      ],
    },
    {
      key: '3',
      label: '포지션관리',
      onClick: () => handleMenuClick('/position/open'),
      children: [
        { label: '활성 포지션', key: '3-1', onClick: () => handleMenuClick('/position/open') },
        { label: '완료 포지션', key: '3-4', onClick: () => handleMenuClick('/position/closed') },
        { label: '청산 포지션', key: '3-2', onClick: () => handleMenuClick('/position/liquid') },
        { label: '청산 근접 포지션', key: '3-3', onClick: () => handleMenuClick('/position/liquid-near') },
      ],
    },
    {
      key: '4',
      label: '이력조회',
      onClick: () => handleMenuClick('/record/transaction-details'),
      children: [
        { label: '거래내역', key: '4-1', onClick: () => handleMenuClick('/record/transaction-details') },
        { label: '활동이력', key: '4-2', onClick: () => handleMenuClick('/record/activity-history') },
        { label: '계좌이력', key: '4-3', onClick: () => handleMenuClick('/record/wallet-history') },
        { label: '계좌목록', key: '4-4', onClick: () => handleMenuClick('/record/wallet-list') },
        { label: '아이피목록', key: '4-5', onClick: () => handleMenuClick('/record/ip-list') },
      ],
    },
    {
      key: '44',
      label: '정산관리',
      onClick: () => handleMenuClick('/balance/all'),
      children: [
        { label: '정산현황', key: '44-1', onClick: () => handleMenuClick('/balance/all') },
        { label: '그룹별정산현황', key: '44-2', onClick: () => handleMenuClick('/balance/group') },
        { label: '일별정산', key: '44-3', onClick: () => handleMenuClick('/balance/daily') },
      ],
    },
    {
      key: '51',
      label: '현금입출금',
      onClick: () => handleMenuClick('/cash/deposit'),
      children: [
        { label: '입금관리', key: '51-1', onClick: () => handleMenuClick('/cash/deposit') },
        { label: '출금관리', key: '51-2', onClick: () => handleMenuClick('/cash/withdrawal') },
        { label: '별도입출금', key: '51-3', onClick: () => handleMenuClick('/cash/other') },
        { label: 'PG입출금', key: '51-4', onClick: () => handleMenuClick('/cash/pg/deposit') },
      ],
    },
    {
      key: '66',
      label: '사용자문의',
      onClick: () => handleMenuClick('/ticket'),
      children: [
        { label: '전체문의', key: '66-0', onClick: () => handleMenuClick('/ticket') },
        { label: '대기', key: '66-1', onClick: () => handleMenuClick('/ticket/0') },
        { label: '검토', key: '66-2', onClick: () => handleMenuClick('/ticket/1') },
        { label: '완료', key: '66-3', onClick: () => handleMenuClick('/ticket/2') },
      ],
    },
    {
      key: '6',
      label: '공지/이벤트',
      onClick: () => handleMenuClick('/events'),
      children: [
        { label: '공지관리', key: '6-1', onClick: () => handleMenuClick('/events/announcements') },
        { label: '이벤트관리', key: '6-2', onClick: () => handleMenuClick('/events/event') },
        { label: '휴면이벤트세팅', key: '6-3', onClick: () => handleMenuClick('/events/human-event') },
      ],
    },
    {
      key: '7',
      label: '시스템',
      onClick: () => handleMenuClick('/system'),
      children: [
        { label: '거래소설정', key: '7-1', onClick: () => handleMenuClick('/system/1') },
        { label: '제한프로그램 설정', key: '7-5', onClick: () => handleMenuClick('/system/5') },
        { label: 'IP차단', key: '7-2', onClick: () => handleMenuClick('/system/2') },
        { label: '팝업설정', key: '7-3', onClick: () => handleMenuClick('/system/3') },
        { label: '환율관리', key: '7-6', onClick: () => handleMenuClick('/system/6') },
        { label: '강제슬리피지', key: '7-7', onClick: () => handleMenuClick('/system/7') },
        { label: '관리자 PC등록', key: '7-4', onClick: () => handleMenuClick('/system/4') },
        { label: '파트너 PC등록', key: '7-8', onClick: () => handleMenuClick('/system/8') },
      ],
    },
  ]

  return (
    <Drawer
      title="메뉴"
      placement="left"
      onClose={onClose}
      open={visible}
      width={280}
    >
      <Menu
        mode="inline"
        items={menuItems}
        style={{ border: 'none' }}
      />
    </Drawer>
  )
}

export default React.memo(MobileMenuDrawer)